module.exports = __webpack_public_path__ + "img/9788952213747.b36a82c3.jpg";